import { FC, useCallback, useEffect } from 'react'
import { ComposeId } from 'interfaces/feed'
import { OuterEvent } from 'components/features/pfm/OuterEvent/OuterEvent'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { composeFocusActionCreator, composeBlurActionCreator } from 'actions/feedComposeActions'
import { useComposeCommand } from 'helpers/composeHooks'
import { useComposeState } from 'helpers/hookHelpers'

type ComposeFocusableProps = {
  composeId: ComposeId
}

export const ComposeFocusable: FC<ComposeFocusableProps> = (props) => {
  const {
    children,
    composeId,
  } = props

  const {
    isFocused,
    focusOnMount,
  } = useComposeState(composeId, { isFocused: false, focusOnMount: false })

  const dispatch = useStoreDispatch()

  const handleFocus = useCallback(() => {
    if (isFocused) {
      return
    }
    dispatch(composeFocusActionCreator({ composeId }))
  }, [composeId, dispatch, isFocused])

  const handleBlur = useCallback(() => {
    if (!isFocused) {
      return
    }
    dispatch(composeBlurActionCreator({ composeId }))
  }, [composeId, dispatch, isFocused])

  useComposeCommand(props, {
    focus: handleFocus,
  })

  useEffect(() => {
    if (focusOnMount) {
      handleFocus()
    }
  }, [focusOnMount, handleFocus])

  return (
    <OuterEvent
      onOuterClick={ handleBlur }
      onClick={ handleFocus }
    >
      { children }
    </OuterEvent>
  )
}
